<template>
  <div class="Footer">
    <div class="text-center">
      Warcraft III is a registered trademark of Blizzard Entertainment.
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style lang="scss">
  .Footer {
    background-color: rgba(0, 0, 0, 0.95);
    border-top: $w3s-border-region;
    height: $w3s-footer-height;  
    line-height: $w3s-footer-height - 8px;
  }
</style>